<template>
  <main class="beta-page">
    <section class="beta-hero" v-reveal>
      <div>
        <p class="section-kicker">{{ beta.kicker }}</p>
        <h1>{{ beta.title }}</h1>
        <p>{{ beta.copy }}</p>
        <div class="hero-actions">
          <a class="action-button action-button--discord action-button--large" :href="beta.primaryAction.href">
            <AppIcon :name="beta.primaryAction.icon" />
            <span>{{ beta.primaryAction.label }}</span>
          </a>
          <a class="action-button action-button--muted action-button--large" :href="beta.secondaryAction.href">
            <AppIcon :name="beta.secondaryAction.icon" />
            <span>{{ beta.secondaryAction.label }}</span>
          </a>
        </div>
      </div>

      <PageMascotVisual />
    </section>

    <section class="beta-voluntary" v-reveal>
      <span><AppIcon name="heart" /></span>
      <div>
        <p class="section-kicker">{{ beta.voluntaryKicker }}</p>
        <h2>{{ beta.voluntaryTitle }}</h2>
        <p>{{ beta.voluntaryCopy }}</p>
      </div>
    </section>

    <section class="beta-highlights" v-reveal>
      <article
        v-for="(item, index) in beta.highlights"
        :key="item.title"
        class="beta-highlight"
        :style="{ '--delay': `${index * 90}ms` }"
      >
        <span><AppIcon :name="item.icon" /></span>
        <h2>{{ item.title }}</h2>
        <p>{{ item.copy }}</p>
      </article>
    </section>

    <section class="beta-process" v-reveal>
      <div>
        <p class="section-kicker">{{ beta.processKicker }}</p>
        <h2>{{ beta.processTitle }}</h2>
      </div>
      <ol>
        <li v-for="step in beta.steps" :key="step.title">
          <strong>{{ step.number }}</strong>
          <div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.copy }}</p>
          </div>
        </li>
      </ol>
    </section>

    <section class="beta-info-grid">
      <article v-reveal>
        <p class="section-kicker">{{ beta.expectationsTitle }}</p>
        <ul>
          <li v-for="expectation in beta.expectations" :key="expectation">
            <AppIcon name="star" />
            <span>{{ expectation }}</span>
          </li>
        </ul>
      </article>
      <article v-reveal>
        <p class="section-kicker">{{ beta.notForTitle }}</p>
        <ul>
          <li v-for="item in beta.notFor" :key="item">
            <AppIcon name="lock" />
            <span>{{ item }}</span>
          </li>
        </ul>
      </article>
    </section>
  </main>
</template>

<script>
import AppIcon from './AppIcon.vue'
import PageMascotVisual from './PageMascotVisual.vue'

export default {
  name: 'BetaTesterPage',
  components: {
    AppIcon,
    PageMascotVisual
  },
  props: {
    beta: {
      type: Object,
      required: true
    }
  }
}
</script>
